import { Chip, TextFieldProps, Typography } from '@mui/material';
import { getCurrencySymbol } from '@zeta-core';

export interface IFieldComponentFieldType {
  component: JSX.ElementType;
  label?: string;
  placeholder?: string;
  options?: any[];
  thousandSeparator?: boolean;
  fixedDecimalScale?: boolean;
  decimalScale?: number;
  prefix?: string;
  suffix?: string;
  prefixText?: string;
  type?: TextFieldProps['type'];
  InputProps?: TextFieldProps['InputProps'];
  onChange?: (event: Date) => void;
  textAlign?: 'right' | 'left';
  multiple?: boolean;
  row?: boolean;
  customColor?: string;
  useGetSetMethods?: boolean;
  shouldDirty?: boolean;
  hideBorder?: boolean;
  componentProps?: any;
}

export const renderComponent = (
  field: IFieldComponentFieldType,
  name: string,
  sxProp?: object,
  disabled = false,
  getOptionLabel?: () => void,
  fArray?: { id: string; currency?: string },
  isClient?: boolean
) => {
  const RenderComponent = field?.component;

  if (!RenderComponent) {
    return null;
  }
  return (
    <RenderComponent
      name={name}
      id={name}
      fullWidth
      disabled={disabled || isClient}
      sx={{ textAlign: field.textAlign || 'left', ...sxProp }}
      {...(field.options && { options: field.options })}
      {...(field.placeholder && { placeholder: field.placeholder })}
      {...(field.onChange && { onChange: field.onChange })}
      {...(field.thousandSeparator && { thousandSeparator: field.thousandSeparator })}
      {...(field.fixedDecimalScale && { fixedDecimalScale: field.fixedDecimalScale })}
      {...(field.decimalScale && { decimalScale: field.decimalScale })}
      {...(field.prefix && { prefix: getCurrencySymbol(fArray?.currency || 'GBP') })}
      {...(field.prefixText && { prefix: `${field.prefixText} ${getCurrencySymbol(fArray?.currency || 'GBP')}` })}
      {...(field.type && { type: field.type })}
      {...(field.InputProps && { InputProps: field.InputProps })}
      {...(field.customColor && { customColor: field.customColor })}
      {...(field.useGetSetMethods && { useGetSetMethods: field.useGetSetMethods })}
      {...(field.shouldDirty && { shouldDirty: field.shouldDirty })}
      {...(field.hideBorder && { hideBorder: field.hideBorder })}
      {...(field.suffix && { suffix: field.suffix })}
      multiple={field?.multiple || undefined}
      row={field?.row || undefined}
      {...(field.multiple && {
        renderTags: (value: any, getTagProps: any) =>
          value.map((option: any, index: number) => (
            <Chip
              sx={{ margin: '8px 4px !important', height: '24px' }}
              variant="soft"
              label={<Typography variant="chipLabel">{option?.label}</Typography>}
              {...getTagProps({ index })}
            />
          )),
        limitTags: 1,
        defaultValue: [],
        isOptionEqualToValue: (option: any, value: any) => option?.value === value?.value,
      })}
      getOptionLabel={getOptionLabel}
      {...field?.componentProps}
    />
  );
};
